export const initialStateSlice = {
  body: null,
  loading: false,
  error: null,
};
